export default __webpack_public_path__ + "static/boge-bafa-stoerer-324d992f63b9bfc9af4098d48a3a1b0b.png";